import FloatingIp from '@/common/models/floatingIp.model';
import i18n from '@/common/i18n';
import { CommonState } from '@/common/store/modules/common/types/CommonState';

const floatingIpsGetters: CommonGetterTree<any> = {
  statuses: () => ({
    ACTIVE: i18n.t('Active'),
    ERROR: i18n.t('Error'),
    DOWN: i18n.t('Inactive'),
  })
};

export default new class implements CommonStore<CommonState, FloatingIp> {
  name = 'floatingIps';
  resource = '/api/v2/compute/floating_ips';
  Model = FloatingIp;
  socketUpdates = true;
  pagingSupport = true;
  getters = floatingIpsGetters;
}();
